import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          textAlign: 'center',
          background: 'var(--bg-main, #0B080F)',
          color: 'var(--text-main, #FDFCFE)',
        }}>
          <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '4rem', color: 'var(--color-orange, #FF5A1F)', marginBottom: '1.5rem' }}></i>
          <h1 style={{ fontFamily: 'var(--font-head)', fontSize: '2.5rem', marginBottom: '1rem' }}>Something went wrong</h1>
          <p style={{ color: 'var(--text-muted, #B3AEBF)', fontSize: '1.1rem', maxWidth: '500px', marginBottom: '2rem' }}>
            We're sorry, an unexpected error occurred. Please try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="btn btn-primary theme-btn"
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
